/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/button-has-type */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import { Tooltip, Box } from "@mui/material";
import styled from "styled-components";
import * as Sentry from "@sentry/react";
import PreviewIcon from "@mui/icons-material/Preview";
import { Helmet } from "react-helmet";
import AppliedFilter from "../Components/AppliedFilter/AppliedFilter";
import { DATES, EVENT_NAME, Constants } from "../Components/constant";
import useParamsQuery from "../Components/hooks/useParamsQuery";
import { isEmptyObj } from "../Components/helper";
import AdvancedSearch from "./Components/NewAdvanceSearch";
import styles from "./MemberSearch.styles";
import DateRangePicker from "../Components/DateRangePicker/DateRangePicker";
import OrganizationStructureForMemberSearch from "../Components/OrganizationStructureNew/OrganizationStructureForMemberSearch";
import NewPopover from "../Components/Popover/NewPopover";
import { SERVICES } from "../../../components/Layout/Services";
import Loader from "../../../components/Loader/Loader";
import SearchIconWithPeople from "../../../components/Svg/SearchIconWithPeople";
import EmptyFileIcon from "../../../components/Svg/EmptyFile";
import PageSyncCal from "../../../components/Layout/PageSyncCal";
import Heading from "../../../components/Layout/Heading";
import { OuterContainerStyles } from "../../../components/Layout/Typography";
import { get } from "../../../components/Layout/ApiHandler/apihandler";
import GenericTable from "./Components/GenericTable";
import Button from "../../../components/Layout/Button";
import PersonalDetailsSearch from "./Components/PersonalDetailsSearch";
import { ToastAlertContext } from "../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import ContributionDetailsSearch from "./Components/ContributionDetailsSearch";
import EditIcon from "../../../components/Svg/EditIcon";
import NewIcon from "../../../components/Svg/NewIcon";
import UpdateIcon from "../../../components/Svg/UpdateIcon";
import ViewIcon from "../../../components/Svg/ViewIcon";
import { ROUTES } from "../../../components/Routes";
import OrganizationStructureForUser from "../Components/OrganizationStructureNew/OrganizationStructureForUser";
import Modal from "../../../components/Modal/Modal";

const LOADER_DELAY = 1000;
const PAGE = "page";

const tableHeaders = [
  "Member ID",
  "Member Name",
  "Division",
  "Address",
  "Contact Info",
  "Org Structure",
  "Actions",
];
const initialFormValue = {
  dateOfBirthFrom: "",
  dateOfBirthTo: "",
};

function MemberSearch() {
  const TITLE = "Member Search - BSG ContributionAdmin";
  const [searchData, setSearchData] = useState({});
  const [data, setData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const metaData = useSelector((state) => state.meta);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [currentPage, setCurrentPage] = useState(0);
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const [values, setValues] = useState({
    areaId: null,
    clusterId: null,
    zoneId: null,
    regionId: null,
    chapterId: null,
    districtId: null,
    blockId: null,
  });
  const [orgNames, setOrgNames] = useState({
    areaName: null,
    clusterName: null,
    zoneName: null,
    regionName: null,
    chapterName: null,
    districtName: null,
    blockName: null,
  });
  const [selectedPayableCity, setSelectedPayableCity] = useState("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState("");
  const [selectedUinType, setSelectedUinType] = useState("");
  const [selectedReceiptType, setSelectedReceiptType] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [clearContributions, setClearContributions] = useState(false);
  const [showFilter, setShowFilter] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const toast = useContext(ToastAlertContext);
  const location = useLocation();
  const [profileData, setProfileData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [personalDetailsValues, setPersonalDetailsValues] = useState({
    id: null,
    fullName: null,
    mobileNumber: null,
    emailId: null,
    address: null,
    pincode: null,
    stateId: null,
    stateName: null,
    cityId: null,
    cityName: null,
    divisionId: null,
    divisionName: null,
    subdivisionId: null,
    subDivisionName: null,
  });
  const [advancedSearchValues, setAdvancedSearchValues] = useState({
    dateOfBirthFrom: "",
    dateOfBirthTo: "",
    dateOfJoiningFrom: "",
    dateOfJoiningTo: "",
    selectedProfession: "",
    selectedMainlinePositions: [],
    mainlinePositions: [],
    positions: [],
    gohonzonTypeOptions: [],
    selectedPositions: [],
    appointedAtFrom: "",
    appointedAtTo: "",
    selectedGohonzonTypes: [],
  });
  const [ContributionDetailsSearchValues, setContributionDetailsSearchValues] =
    useState({
      selectedPayment: "",
      contributionDateTo: "",
      contributionDateFrom: "",
      amountFrom: "",
      amountTo: "",
      receiptNumberFrom: "",
      receiptNumberTo: "",
      receiptDateFrom: "",
      receiptDateTo: "",
      chequeNumber: "",
      ddNumber: "",
      orderId: "",
    });
  const [amountValue, setAmountValue] = useState(null);
  const SelectedUser = useSelector((state) => state.user);

  // ADD THIS NEW FUNCTION FOR ENTER KEY HANDLING
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission
      if (formRef.current) {
        // Trigger form submit programmatically
        formRef.current.requestSubmit();
      }
    }
  };

  const handleAmountChange = (value) => {
    setAmountValue(value);
  };

  const handlePersonalDetailsChange = (values) => {
    setPersonalDetailsValues(values);
  };

  const updatePayableCity = (value) => {
    setSelectedPayableCity(value);
  };

  const updatePaymentMethod = (value) => {
    setSelectedPaymentMethod(value);
  };

  const updatePaymentGateway = (value) => {
    setSelectedPaymentGateway(value);
  };

  const updateUinType = (value) => {
    setSelectedUinType(value);
  };

  const updateReceiptType = (value) => {
    setSelectedReceiptType(value);
  };

  const updateOrganizationStructureValues = (updatedValues) => {
    setValues(updatedValues);
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    const updatedQuery = {
      ...queryObject,
      pageNumber: 0,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
    };
    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }
    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }
    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    updatedSearchParams.delete(filterKey);
    setSearchParams(updatedSearchParams.toString());
  };

  const onRemoveTwoFilter = (...filterKeys) => {
    const updatedSearchParams = new URLSearchParams(searchParams);
    filterKeys.forEach((key) => {
      updatedSearchParams.delete(key);
    });

    setSearchParams(updatedSearchParams.toString());
  };

  function formatDateToYYYYMMDD(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  const constructQueryParameters = (formattedStartDate, formattedEndDate) => {
    const queryParams = [];
    const optionalParams = {
      inOrganisationStructure: false,
      areaId: values.areaId,
      clusterId: values.clusterId,
      zoneId: values.zoneId,
      regionId: values.regionId,
      chapterId: values.chapterId,
      districtId: values.districtId,
      blockId: values.blockId,
      memberId: personalDetailsValues.id,
      fullName: personalDetailsValues.fullName,
      mobileNumber: personalDetailsValues.mobileNumber,
      emailId: personalDetailsValues.emailId,
      address: personalDetailsValues.address,
      pincode: personalDetailsValues.pincode,
      stateId: personalDetailsValues.stateId,
      cityId: personalDetailsValues.cityId,
      divisionId: personalDetailsValues.divisionId,
      subdivisionId: personalDetailsValues.subdivisionId,
      dateOfBirthFrom: moment(advancedSearchValues.dateOfBirthFrom).isValid()
        ? moment(advancedSearchValues.dateOfBirthFrom).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      dateOfBirthTo: moment(advancedSearchValues.dateOfBirthTo).isValid()
        ? moment(advancedSearchValues.dateOfBirthTo).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      dateOfJoiningFrom: moment(
        advancedSearchValues.dateOfJoiningFrom,
      ).isValid()
        ? moment(advancedSearchValues.dateOfJoiningFrom).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      dateOfJoiningTo: moment(advancedSearchValues.dateOfJoiningTo).isValid()
        ? moment(advancedSearchValues.dateOfJoiningTo).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      professionsId: advancedSearchValues.selectedProfession,
      mainlinePositionIds:
        advancedSearchValues.selectedMainlinePositions.join(","),
      dualPositionIds: advancedSearchValues.selectedPositions.join(","),
      appointedAtFrom: moment(advancedSearchValues.appointedAtFrom).isValid()
        ? moment(advancedSearchValues.appointedAtFrom).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      appointedAtTo: moment(advancedSearchValues.appointedAtTo).isValid()
        ? moment(advancedSearchValues.appointedAtTo).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      conferralDateFrom: moment(
        advancedSearchValues.conferralDateFrom,
      ).isValid()
        ? moment(advancedSearchValues.conferralDateFrom).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      conferralDateTo: moment(advancedSearchValues.conferralDateTo).isValid()
        ? moment(advancedSearchValues.conferralDateTo).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      gohonzonTypes: advancedSearchValues.selectedGohonzonTypes.join(","),
      modeOfPayment: ContributionDetailsSearchValues.selectedPayment,
      amountFrom: ContributionDetailsSearchValues.amountFrom,
      amountTo: ContributionDetailsSearchValues.amountTo,
      contributionDateFrom: moment(
        ContributionDetailsSearchValues.contributionDateFrom,
      ).isValid()
        ? moment(ContributionDetailsSearchValues.contributionDateFrom).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      contributionDateTo: moment(
        ContributionDetailsSearchValues.contributionDateTo,
      ).isValid()
        ? moment(ContributionDetailsSearchValues.contributionDateTo).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      chequeNumber: ContributionDetailsSearchValues.chequeNumber,
      receiptNumberFrom: ContributionDetailsSearchValues.receiptNumberFrom,
      receiptNumberTo: ContributionDetailsSearchValues.receiptNumberTo,
      orderId: ContributionDetailsSearchValues.orderId,
      receiptDateFrom: moment(
        ContributionDetailsSearchValues.receiptDateFrom,
      ).isValid()
        ? moment(ContributionDetailsSearchValues.receiptDateFrom).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
      receiptDateTo: moment(
        ContributionDetailsSearchValues.receiptDateTo,
      ).isValid()
        ? moment(ContributionDetailsSearchValues.receiptDateTo).format(
            "YYYY-MM-DDTHH:mm:ss",
          )
        : null,
    };
    for (const key in optionalParams) {
      if (
        optionalParams[key] !== null &&
        optionalParams[key] !== undefined &&
        optionalParams[key] !== ""
      ) {
        queryParams.push(`${key}=${optionalParams[key]}`);
      }
    }
    if (
      moment(formattedStartDate, "YYYY-MM-DD", true).isValid() &&
      moment(formattedEndDate, "YYYY-MM-DD", true).isValid()
    ) {
      queryParams.push(`from=${formattedStartDate}`);
      queryParams.push(`to=${formattedEndDate}`);
    }
    return queryParams.join("&");
  };

  const removeFilter = () => {
    setClearContributions(true);
    setSearchParams("");
    setPersonalDetailsValues({
      id: null,
      fullName: null,
      mobileNumber: null,
      emailId: null,
      address: null,
      pincode: null,
      stateId: null,
      stateName: null,
      cityId: null,
      cityName: null,
      divisionId: null,
      divisionName: null,
      subdivisionId: null,
      subDivisionName: null,
    });
    setTimeout(() => {
      setClearContributions(false);
      setSearchPerformed(false);
      setShowFilter(false);
      setShowModal(false);
    }, 100);
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    // Validation: Check if any filter is selected
    const hasOrgFilter = Object.values(values).some((val) => val !== null);
    const hasPersonalFilter = Object.values(personalDetailsValues).some(
      (val) => val !== null && val !== "",
    );
    const hasAdvancedFilter =
      advancedSearchValues.dateOfBirthFrom ||
      advancedSearchValues.dateOfJoiningFrom ||
      advancedSearchValues.selectedProfession ||
      advancedSearchValues.selectedMainlinePositions.length > 0;
    const hasContributionFilter = Object.values(
      ContributionDetailsSearchValues,
    ).some((val) => val !== null && val !== "");

    if (
      !hasOrgFilter &&
      !hasPersonalFilter &&
      !hasAdvancedFilter &&
      !hasContributionFilter
    ) {
      toast.show("Please select your search filter", AlertStatus.ERROR);
      return;
    }

    setSearchPerformed(false);
    const formattedStartDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthFrom,
    );
    const formattedEndDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.dateOfBirthTo,
    );
    try {
      setIsLoading(true);
      const url = `${SERVICES.GET_MEMBER_SEARCH}?${constructQueryParameters(
        formattedStartDate,
        formattedEndDate,
      )}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();

        // Check if no data found
        if (data.data.totalElements === 0) {
          toast.show("No data found", AlertStatus.ERROR);
          setIsLoading(false);
          return;
        }

        setSearchData(data.data);
        setSearchPerformed(true);
        setShowModal(true);

        const queryParams = constructQueryParameters(
          formattedStartDate,
          formattedEndDate,
        );

        const {
          areaId,
          clusterId,
          zoneId,
          regionId,
          chapterId,
          districtId,
          blockId,
        } = values;
        const {
          areaName,
          clusterName,
          zoneName,
          regionName,
          chapterName,
          districtName,
          blockName,
        } = orgNames;
        const orgParams = [
          areaId !== null && areaName !== null && areaName !== ""
            ? `areaName=${areaName}`
            : "",
          clusterId !== null && clusterName !== null && clusterName !== ""
            ? `clusterName=${clusterName}`
            : "",
          zoneId !== null && zoneName !== null && zoneName !== ""
            ? `zoneName=${zoneName}`
            : "",
          regionId !== null && regionName !== null && regionName !== ""
            ? `regionName=${regionName}`
            : "",
          chapterId !== null && chapterName !== null && chapterName !== ""
            ? `chapterName=${chapterName}`
            : "",
          districtId !== null && districtName !== null && districtName !== ""
            ? `districtName=${districtName}`
            : "",
          blockId !== null && blockName !== null && blockName !== ""
            ? `blockName=${blockName}`
            : "",
        ]
          .filter(Boolean)
          .join("&");

        const {
          stateId,
          cityId,
          divisionId,
          subdivisionId,
          stateName,
          cityName,
          divisionName,
          subDivisionName,
        } = personalDetailsValues;
        const personalDetailsParams = [
          stateId !== null && stateName !== null && stateName !== ""
            ? `stateName=${stateName}`
            : "",
          cityId !== null && cityName !== null && cityName !== ""
            ? `cityName=${cityName}`
            : "",
          divisionId !== null && divisionName !== null && divisionName !== ""
            ? `divisionName=${divisionName}`
            : "",
          subdivisionId !== null &&
          subDivisionName !== null &&
          subDivisionName !== ""
            ? `subDivisionName=${subDivisionName}`
            : "",
        ]
          .filter(Boolean)
          .join("&");

        const selectedMainlinePositionsName =
          advancedSearchValues.mainlinePositions
            .filter((position) =>
              advancedSearchValues.selectedMainlinePositions.includes(
                position.value,
              ),
            )
            .map((position) => position.entityTitle);

        const selectedPositionsNames = advancedSearchValues.positions
          .filter((position) =>
            advancedSearchValues.selectedPositions.includes(position.value),
          )
          .map((position) => position.entityTitle);

        setSearchParams(
          `${queryParams}${orgParams ? `&${orgParams}` : ""}${
            personalDetailsParams ? `&${personalDetailsParams}` : ""
          }${
            selectedMainlinePositionsName.length
              ? `&selectedMainlinePositionsName=${selectedMainlinePositionsName}`
              : ""
          }${
            selectedPositionsNames.length
              ? `&selectedPositionsName=${selectedPositionsNames}`
              : ""
          }`,
        );
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      } else {
        setIsLoading(false);
        toast.show("No data found", AlertStatus.ERROR);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
      toast.show("No data found", AlertStatus.ERROR);
    }
    document.dispatchEvent(new Event(EVENT_NAME));
  };

  const fetchData = async () => {
    setSearchPerformed(true);
    try {
      setIsLoading(true);
      const clonedSearchParams = new URLSearchParams(searchParams);
      const parametersToRemove = [
        "areaName",
        "clusterName",
        "zoneName",
        "regionName",
        "chapterName",
        "districtName",
        "blockName",
        "stateName",
        "cityName",
        "divisionName",
        "subDivisionName",
        "selectedMainlinePositionsName",
        "selectedPositionsName",
      ];

      parametersToRemove.forEach((key) => clonedSearchParams.delete(key));

      const url = `${
        SERVICES.GET_MEMBER_SEARCH
      }?${clonedSearchParams.toString()}`;

      const response = await get(url);

      if (response.ok) {
        const data = await response.json();
        setSearchData(data.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (searchParams.size === 1) {
      removeFilter();
    }
    if (searchParams.size > 0) {
      fetchData();
    }
  }, [searchParams]);

  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    const formattedStartDate = moment(
      initialAdvanceFormValue.dateOfBirthFrom,
    ).format("YYYY-MM-DD");
    const formattedEndDate = moment(
      initialAdvanceFormValue.dateOfBirthTo,
    ).format("YYYY-MM-DD");
    try {
      const url = `${SERVICES.GET_MEMBER_SEARCH}?${constructQueryParameters(
        formattedStartDate,
        formattedEndDate,
        selectedPayableCity,
        selectedPaymentMethod,
        selectedPaymentGateway,
      )}&page=${selectedPage}&size=${10}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setSearchData(data.data);
      } else {
        console.error("Failed to fetch contribution data");
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (searchData.content) {
      const updatedTableData = searchData.content.map((item, index) => {
        return {
          "Member ID": item?.id,
          "Member Name": item?.fullName,
          Division: item?.divisionName,
          Address: item?.addressLine1,
          "Contact Info": (
            <div>
              <div>{item?.mobileNumber}</div>
            </div>
          ),
          "Org Structure": `${item?.areaName || "NA"}/
          ${item?.clusterName || "NA"}/
          ${item?.zoneName || "NA"}/
          ${item?.regionName || "NA"}/${item?.chapterName || "NA"}/${
            item?.districtName || "NA"
          }/${item?.blockName || "NA"}`,
          Actions:
            item?.divisionName !== "FD(B)" &&
            item?.divisionName !== "FD(G)" &&
            item?.nationalityId === 99 ? (
              <div
                style={{ display: "flex", gap: "10px", justifyContent: "left" }}
              >
                {" "}
                <Tooltip title="New Contribution" placement="top">
                  <div>
                    <NewIcon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(
                          `${ROUTES.MEMBER_CONTRIBUTION_DETAILS}/${item?.id}`,
                        )
                      }
                    />
                  </div>
                </Tooltip>
                <Tooltip title="View Contribution" placement="top">
                  <div>
                    <ViewIcon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(
                          `${ROUTES.MEMBER_CONTRIBUTION_VIEW}/${item?.id}`,
                        )
                      }
                    />
                  </div>
                </Tooltip>
                <Tooltip title="Member View" placement="top">
                  <div>
                    <PreviewIcon
                      style={{
                        cursor: "pointer",
                        height: "16px",
                        width: "16px",
                        color: "#484848",
                      }}
                      onClick={() =>
                        navigate(`${ROUTES.MEMBER_VIEW}/${item?.id}`)
                      }
                    />
                  </div>
                </Tooltip>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  background: "rgb(255, 66, 94)",
                  color: "white",
                  textAlign: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "5px",
                  height: "24px",
                }}
              >
                Member not eligible
              </div>
            ),
        };
      });

      setData(updatedTableData);
    }
  }, [searchData.content]);

  useEffect(() => {
    Object.keys(initialFormValue).forEach((key) => {
      setInitialAdvanceFormValue((prev) => ({
        ...prev,
      }));
    });
  }, [urlSearchParams.toString()]);

  const clearAllFilter = () => {
    updateSearchParam();
  };

  const queryParams = new URLSearchParams(location.search);

  const renderAppliedFilter = (paramKey, displayName, value, onRemove) => {
    return (
      queryParams.get(paramKey) && (
        <AppliedFilter
          filter={{
            displayName,
            value,
          }}
          onRemove={onRemove}
        />
      )
    );
  };

  const convertGohonzonTypeFormat = (gohonzonType) => {
    const formattedType = gohonzonType
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    return formattedType;
  };

  const getEntityTitlesForSelectedPositions = () => {
    return queryParams
      ?.get("selectedMainlinePositionsName")
      ?.split(",")
      ?.map((name) => name.trim());
  };

  const getEntityTitlesForDualSelectedPositions = () => {
    return queryParams
      ?.get("selectedPositionsName")
      ?.split(",")
      ?.map((name) => name.trim());
  };

  const getEntityTitlesForGohonzonTypesPositions = () => {
    const gohonzonTypes = queryParams?.get("gohonzonTypes");

    if (gohonzonTypes) {
      return gohonzonTypes
        ?.split(",")
        ?.map((name) => convertGohonzonTypeFormat(name.trim()));
    }

    return [];
  };

  const filters = [
    renderAppliedFilter("areaId", "Area", searchParams.get("areaName"), () =>
      onRemoveTwoFilter("areaId", "areaName"),
    ),
    renderAppliedFilter(
      "clusterId",
      "Cluster",
      searchParams.get("clusterName"),
      () => onRemoveTwoFilter("clusterId", "clusterName"),
    ),
    renderAppliedFilter("zoneId", "Zone", searchParams.get("zoneName"), () =>
      onRemoveTwoFilter("zoneId", "zoneName"),
    ),
    renderAppliedFilter(
      "regionId",
      "Region",
      searchParams.get("regionName"),
      () => onRemoveTwoFilter("regionId", "regionName"),
    ),
    renderAppliedFilter(
      "chapterId",
      "Chapter",
      searchParams.get("chapterName"),
      () => onRemoveTwoFilter("chapterId", "chapterName"),
    ),
    renderAppliedFilter(
      "districtId",
      "District",
      searchParams.get("districtName"),
      () => onRemoveTwoFilter("districtId", "districtName"),
    ),
    renderAppliedFilter("blockId", "Block", searchParams.get("blockName"), () =>
      onRemoveTwoFilter("blockId", "blockName"),
    ),
    renderAppliedFilter(
      "memberId",
      "Member Id",
      searchParams.get("memberId"),
      () => onRemoveFilter("memberId"),
    ),
    renderAppliedFilter(
      "fullName",
      "Member Name",
      searchParams.get("fullName"),
      () => onRemoveFilter("fullName"),
    ),
    renderAppliedFilter(
      "mobileNumber",
      "Mobile Number",
      searchParams.get("mobileNumber"),
      () => onRemoveFilter("mobileNumber"),
    ),
    renderAppliedFilter(
      "emailId",
      "Email Id",
      searchParams.get("emailId"),
      () => onRemoveFilter("emailId"),
    ),
    renderAppliedFilter("address", "Address", searchParams.get("address"), () =>
      onRemoveFilter("address"),
    ),
    renderAppliedFilter("pincode", "Pincode", searchParams.get("pincode"), () =>
      onRemoveFilter("pincode"),
    ),
    renderAppliedFilter("stateId", "State", searchParams.get("stateName"), () =>
      onRemoveTwoFilter("stateId", "stateName"),
    ),
    renderAppliedFilter("cityId", "City", searchParams.get("cityName"), () =>
      onRemoveTwoFilter("cityId", "cityName"),
    ),
    renderAppliedFilter(
      "divisionId",
      "Division",
      searchParams.get("divisionName"),
      () => onRemoveTwoFilter("divisionId", "divisionName"),
    ),
    renderAppliedFilter(
      "subdivisionId",
      "Sub Division",
      searchParams.get("subDivisionName"),
      () => onRemoveTwoFilter("subdivisionId", "subDivisionName"),
    ),
    renderAppliedFilter(
      "dateOfBirthFrom",
      "Date of Birth",
      `${moment(searchParams.get("dateOfBirthFrom")).format(
        "DD-MMM-YYYY",
      )} - ${moment(searchParams.get("dateOfBirthTo")).format("DD-MMM-YYYY")}`,
      () => onRemoveTwoFilter("dateOfBirthFrom", "dateOfBirthTo"),
    ),
    renderAppliedFilter(
      "dateOfJoiningFrom",
      "Date of Joining",
      `${moment(searchParams.get("dateOfJoiningFrom")).format(
        "DD-MMM-YYYY",
      )} - ${moment(searchParams.get("dateOfJoiningTo")).format(
        "DD-MMM-YYYY",
      )}`,
      () => onRemoveTwoFilter("dateOfJoiningFrom", "dateOfJoiningTo"),
    ),
    renderAppliedFilter(
      "mainlinePositionIds",
      "Mainline Positions",
      getEntityTitlesForSelectedPositions()?.join(", "),
      () =>
        onRemoveTwoFilter(
          "mainlinePositionIds",
          "selectedMainlinePositionsName",
        ),
    ),
    renderAppliedFilter(
      "dualPositionIds",
      "Positions",
      getEntityTitlesForDualSelectedPositions()?.join(", "),
      () => onRemoveTwoFilter("dualPositionIds", "selectedPositionsName"),
    ),
    renderAppliedFilter(
      "appointedAtFrom",
      "Appointment Date",
      `${moment(searchParams.get("appointedAtFrom")).format(
        "DD-MMM-YYYY",
      )} - ${moment(searchParams.get("appointedAtTo")).format("DD-MMM-YYYY")}`,
      () => onRemoveTwoFilter("appointedAtFrom", "appointedAtTo"),
    ),
    renderAppliedFilter(
      "conferralDateFrom",
      "Conferral Date",
      `${moment(searchParams.get("conferralDateFrom")).format(
        "DD-MMM-YYYY",
      )} - ${moment(searchParams.get("conferralDateTo")).format(
        "DD-MMM-YYYY",
      )}`,
      () => onRemoveTwoFilter("conferralDateFrom", "conferralDateTo"),
    ),
    renderAppliedFilter(
      "gohonzonTypes",
      "Gohonzon",
      getEntityTitlesForGohonzonTypesPositions()?.join(", "),
      () => onRemoveFilter("gohonzonTypes"),
    ),
    renderAppliedFilter(
      "contributionDateFrom",
      "Contribution Date",
      `${moment(searchParams.get("contributionDateFrom")).format(
        "DD-MMM-YYYY",
      )} - ${moment(searchParams.get("contributionDateTo")).format(
        "DD-MMM-YYYY",
      )}`,
      () => onRemoveTwoFilter("contributionDateFrom", "contributionDateTo"),
    ),
    renderAppliedFilter(
      "modeOfPayment",
      "Mode Of Payment",
      searchParams.get("modeOfPayment"),
      () => onRemoveFilter("modeOfPayment"),
    ),
    renderAppliedFilter(
      "amountFrom",
      "Amount",
      `${searchParams.get("amountFrom")}₹ - ${searchParams.get("amountTo")}₹`,
      () => onRemoveTwoFilter("amountFrom", "amountTo"),
    ),
    renderAppliedFilter(
      "receiptNumberFrom",
      "Receipt No",
      `${searchParams.get("receiptNumberFrom")} - ${searchParams.get(
        "receiptNumberTo",
      )}`,
      () => onRemoveTwoFilter("receiptNumberFrom", "receiptNumberTo"),
    ),
    renderAppliedFilter(
      "receiptDateFrom",
      "Receipt Date",
      `${moment(searchParams.get("receiptDateFrom")).format(
        "DD-MMM-YYYY",
      )} - ${moment(searchParams.get("receiptDateTo")).format("DD-MMM-YYYY")}`,
      () => onRemoveTwoFilter("receiptDateFrom", "receiptDateTo"),
    ),
    renderAppliedFilter(
      "chequeNumber",
      "Cheque No",
      searchParams.get("chequeNumber"),
      () => onRemoveFilter("chequeNumber"),
    ),
    renderAppliedFilter(
      "orderId",
      "Order Id",
      searchParams.get("orderId"),
      () => onRemoveFilter("orderId"),
    ),
  ];

  useEffect(() => {
    if (queryParams.get("stateId") === null) {
      setPersonalDetailsValues((prevValues) => ({
        ...prevValues,
        stateId: null,
      }));
    }
    if (queryParams.get("cityId") === null) {
      setPersonalDetailsValues((prevValues) => ({
        ...prevValues,
        cityId: null,
      }));
    }
    if (queryParams.get("divisionId") === null) {
      setPersonalDetailsValues((prevValues) => ({
        ...prevValues,
        divisionId: null,
      }));
    }
    if (queryParams.get("subdivisionId") === null) {
      setPersonalDetailsValues((prevValues) => ({
        ...prevValues,
        subdivisionId: null,
      }));
    }
  }, [
    queryParams.get("stateId"),
    queryParams.get("cityId"),
    queryParams.get("divisionId"),
    queryParams.get("subdivisionId"),
    clearContributions,
  ]);

  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    getUserRole();
  }, []);

  useEffect(() => {
    if (profileData?.assignedRoles?.includes("contributionOfflineDataEntry")) {
      setAdvancedSearchValues((prevValues) => ({
        ...prevValues,
        conferralDateFrom: "",
        conferralDateTo: "",
      }));
    }
  }, [profileData]);

  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Member Search" />
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        {/* ADD onKeyDown TO FORM */}
        <form
          onSubmit={onSubmit}
          ref={formRef}
          style={{ padding: "15px" }}
          onKeyDown={handleKeyDown}
        >
          {/* Organization Structure with Reset Button */}
          <Box sx={{ mb: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Box sx={{ fontWeight: 600, fontSize: "15px" }}>
                Organization Structure
              </Box>
              <Button
                cancel
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  removeFilter();
                }}
                style={{ padding: "6px 16px" }}
              >
                Reset
              </Button>
            </Box>
            {profileData?.assignedRoles?.includes(
              "contributionOfflineDataEntry",
            ) ? (
              <OrganizationStructureForUser
                clearValues={clearContributions}
                setNameValues={setOrgNames}
                onUpdateValues={updateOrganizationStructureValues}
                initialAreaId={profileData?.areaId}
                initialClusterId={profileData?.clusterId}
                initialZoneId={profileData?.zoneId}
                initialRegionId={profileData?.regionId}
                initialChapterId={profileData?.chapterId}
                disabled
              />
            ) : (
              <OrganizationStructureForMemberSearch
                clearValues={clearContributions}
                setNameValues={setOrgNames}
                onUpdateValues={updateOrganizationStructureValues}
              />
            )}
          </Box>

          {/* Personal Details */}
          <Box sx={{ mb: 2 }}>
            <Box sx={{ mb: 1, fontWeight: 600, fontSize: "15px" }}>
              Personal Details
            </Box>
            <PersonalDetailsSearch
              clearValues={clearContributions}
              onDetailsChange={handlePersonalDetailsChange}
              setPersonalDetailsValues={setPersonalDetailsValues}
            />
          </Box>

          {/* Advanced Search & Contribution Details */}
          {(profileData?.assignedRoles?.includes("contributionAdmin") ||
            profileData?.assignedRoles?.includes("contributionDataEntry")) && (
            <>
              <Box sx={{ mb: 2 }}>
                <Box sx={{ mb: 1, fontWeight: 600, fontSize: "15px" }}>
                  Advanced Search
                </Box>
                <AdvancedSearch
                  clearValues={clearContributions}
                  updatePayableCity={updatePayableCity}
                  updatePaymentMethod={updatePaymentMethod}
                  updatePaymentGateway={updatePaymentGateway}
                  updateUinType={updateUinType}
                  updateReceiptType={updateReceiptType}
                  onAmountChange={handleAmountChange}
                  advancedSearchValues={advancedSearchValues}
                  setAdvancedSearchValues={setAdvancedSearchValues}
                />
              </Box>

              <Box sx={{ mb: 2 }}>
                <Box sx={{ mb: 1, fontWeight: 600, fontSize: "15px" }}>
                  Contribution Details
                </Box>
                <ContributionDetailsSearch
                  clearValues={clearContributions}
                  setContributionDetailsSearchValues={
                    setContributionDetailsSearchValues
                  }
                />
              </Box>
            </>
          )}

          {/* Search Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button type="submit">Search</Button>
          </Box>
        </form>

        {/* Results Modal */}
        {showModal && (
          <Modal
            open={showModal}
            onClose={() => setShowModal(false)}
            customStyle={{
              width: "97%",
              maxWidth: "100%",
              height: "92%",
              maxHeight: "100%",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              padding: "10px 10px 2px",
              marginTop: "15px",
            }}
          >
            <Box
              sx={{ display: "flex", flexDirection: "column", height: "100%" }}
            >
              {/* Applied Filters & Buttons in Same Row */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  mb: 2,
                }}
              >
                {/* Applied Filters - Left Side */}
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {filters.map((filter, index) => (
                      <React.Fragment key={index}>{filter}</React.Fragment>
                    ))}
                  </Box>
                </Box>

                {/* Buttons - Right Side, Same Level */}
                <Box sx={{ display: "flex", gap: 2, ml: 2, flexShrink: 0 }}>
                  <Button
                    cancel
                    onClick={() => {
                      removeFilter();
                    }}
                  >
                    Clear Filter
                  </Button>
                  <Button onClick={() => setShowModal(false)}>Back</Button>
                </Box>
              </Box>

              {/* Search Result Count */}
              {data?.length > 0 && (
                <Box sx={{ mb: 2, fontWeight: 600, fontSize: "16px" }}>
                  Search Result: {searchData.totalElements} (Members Found)
                </Box>
              )}

              {/* Table - Scrollable */}
              <Box sx={{ flex: 1, overflowY: "auto" }}>
                {data?.length > 0 ? (
                  <GenericTable
                    tableData={data}
                    data={searchData}
                    headers={tableHeaders}
                    onPageChange={handlePageChange}
                  />
                ) : (
                  <Box sx={{ textAlign: "center", py: 4 }}>
                    <EmptyFileIcon width={100} />
                    <Box sx={{ mt: 2, fontSize: "16px" }}>
                      No data found with current Filters
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Modal>
        )}

        {isLoading && <Loader />}
      </OuterContainerStyles>
    </div>
  );
}

export default MemberSearch;
